import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { formValues } from 'redux-form';
import allCategories from 'lib/categoriesMapper';
import sortBy from 'lodash/sortBy';
import last from 'lodash/last';
import styles from './CategoryPricingTierInfo.scss';

const CategoryPricingTierInfo = formValues({
  category_id: 'category_id', sub_categories: 'sub_categories'
})(props => {
  if (!props.category_id) {
    return null;
  }

  const categories = allCategories(props.category_id, props.sub_categories, props.categories);
  const highestPricingCategory = last(sortBy(categories, ['pricing_tier_level']));

  return (
    <div className="row">
      <div className="col-12">
        <div className={styles.infoBox}>
          {`Your selected categor${categories.length > 1 ? 'ies are' : 'y is'} on the ${highestPricingCategory.market_name} plan`}
          <br/>
          {props.maxPricingTier && highestPricingCategory.pricing_tier_level > props.maxPricingTier &&
            <span className="text-warning"><i className="fa fa-exclamation-triangle"></i>
              {'That\'s above your current plan. You\'ll need to upgrade in a moment to get that extra coverage.'}</span>}
          {props.maxPricingTier && highestPricingCategory.pricing_tier_level <= props.maxPricingTier &&
            <span className="text-success"><i className="fa fa-check"></i>{'That\'s within your current plan.'}</span>}
        </div>
      </div>
    </div>
  );
});

CategoryPricingTierInfo.propTypes = {
  categories: PropTypes.array.isRequired,
  currentUser: ImmutablePropTypes.map,
  maxPricingTier: PropTypes.number,
};

export default CategoryPricingTierInfo;



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/CategoryPricingTierInfo.jsx